<template>
  <div class="order-card" @click="handleClick">
    <div class="order-card__header">
      <div class="order-card__title">{{ order.productName }}</div>
      <div class="order-card__status" :style="{ color: getStatusColor(order.orderStatus) }">
        {{ getStatusText(order.orderStatus) }}
      </div>
    </div>
    <div class="order-card__body">
      <div class="order-card__meta">
        <div v-if="order.useCalendarPrice !== false" class="order-card__item">
          <div class="order-card__label">规格</div>
          <div class="order-card__value">{{ order.skuName }}</div>
        </div>
        <div class="order-card__item">
          <div class="order-card__label">出行日期</div>
          <div class="order-card__value">{{ formatDate(order.travelDate) }}</div>
        </div>
      </div>
      <div class="order-card__footer">
        <div class="order-card__amount">¥{{ order.payAmount || order.orderAmount }}</div>
        <div class="order-card__date">{{ formatDate(order.createTime) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, getOrderStatusText, getOrderStatusColor } from '@/utils/format'

export default {
  name: 'OrderCard',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.order)
    },
    formatDate,
    getStatusText: getOrderStatusText,
    getStatusColor: getOrderStatusColor
  }
}
</script>

<style lang="scss" scoped>
.order-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 12px;
  margin-bottom: 12px;
  transition: all 0.3s ease;

  &:active {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__status {
    font-size: 12px;
    font-weight: 600;
    margin-left: 8px;
    white-space: nowrap;
  }

  &__body {
    border-top: 1px solid #f3f4f6;
    padding-top: 12px;
  }

  &__meta {
    display: flex;
    gap: 16px;
    margin-bottom: 12px;
  }

  &__item {
    flex: 1;
  }

  &__label {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 13px;
    color: #111827;
    font-weight: 500;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__amount {
    font-size: 14px;
    font-weight: 700;
    color: #ff720d;
  }

  &__date {
    font-size: 12px;
    color: #9ca3af;
  }
}
</style>
